import fetchWrapper from "../lib/apiCall";

const loginService = async (payload, signal = null) => {
  try {
    const loginData = await fetchWrapper.apiCall(
      "/auth",
      "POST",
      payload,
      null,
      signal,
      true
    );

    return loginData.results;
  } catch (e) {
    const error = new Error();

    if (e.message.includes("UNAUTHORIZED")) {
      error.message = "Invalid Email/Password";
    } else if (e.message.includes("FORBIDDEN")) {
      error.message =
        "Your account has been deactivated. Please contact your administrator.";
    }

    throw error;
  }
};

const logoutService = async (signal = null) => {
  try {
    await fetchWrapper.apiCall("/auth/logout", "PUT", null, null, signal);

    return true;
  } catch {
    throw new Error("Unable to logout");
  }
};

const checkLogin = async (signal = null) => {
  try {
    const authData = await fetchWrapper.apiCall(
      "/auth/check-login",
      "GET",
      null,
      null,
      signal
    );

    if (!authData) {
      throw new Error("No Credentials");
    }

    return authData.results;
  } catch (e) {
  }
};

const AuthServices = {
  loginService,
  logoutService,
  checkLogin,
};

export default AuthServices;
